define('services/taskmanager',["require", "exports", "common/guid"], function (require, exports, Guid) {
    "use strict";
    var Task = (function () {
        function Task(title, isBlockingTask, status) {
            this.id = Guid.generate();
            this.title = title;
            this.status = status;
            this.isBlockingTask = isBlockingTask;
            ko.track(this, ["title", "status"]);
        }
        return Task;
    }());
    exports.Task = Task;
    var Manager = (function () {
        function Manager() {
            var _this = this;
            this.hasRunningTasks = ko.computed(function () {
                return _this.tasks().length > 0;
            }, this);
        }
        Object.defineProperty(Manager.prototype, "tasks", {
            get: function () {
                return Manager._tasks;
            },
            enumerable: true,
            configurable: true
        });
        Manager.prototype.add = function (title, isBlockingTask, status) {
            if (isBlockingTask === void 0) { isBlockingTask = true; }
            if (status === void 0) { status = ""; }
            var task = new Task(title, isBlockingTask, status);
            this.tasks.push(task);
            return task.id;
        };
        Manager.prototype.startAsync = function (title, action) {
            var _this = this;
            var id = this.add(title);
            return action().finally(function () {
                _this.remove(id);
            });
        };
        Manager.prototype.start = function (title, action) {
            var id = this.add(title);
            action();
            this.remove(id);
        };
        Manager.prototype.startWithStatus = function (title, status) {
            var id = this.add(title, true, status);
            return id;
        };
        Manager.prototype.updateLoaderStatus = function (id, newStatus) {
            var task = ko.utils.arrayFirst(this.tasks(), function (task) {
                return task.id === id;
            });
            task.status = newStatus;
        };
        Manager.prototype.remove = function (id) {
            this.tasks.remove(function (t) { return t.id == id; });
        };
        Manager._tasks = ko.observableArray();
        return Manager;
    }());
    exports.Manager = Manager;
});

